import React from 'react';
import { TFunction } from 'i18next';
import { ApiToken, ApiTokenStatusEnum } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import { CellProps } from '@lib/components/Table/types';
import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import { dateTimeFormatEU } from '@lib/enums/dateTime';
import ApiTokenStatusChip from '@lib/components/ApiTokenStatusChip/ApiTokenStatusChip';

type ColumnsArgs = {
  t: TFunction<'translation', undefined>;
  onStatusChangeHandler: (id: string, newStatus: ApiTokenStatusEnum) => void;
};

export default function getTableColumns({
  t,
  onStatusChangeHandler,
}: ColumnsArgs) {
  return [
    {
      id: 'label',
      Header: t('token-label'),
      accessorFn: ({ item }: CellProps<ApiToken>) => item?.label ?? '-',
      Cell: (props: CellProps<ApiToken>) => <TextCell {...props} />,
      minWidth: 180,
      maxWidth: 180,
      width: 180,
    },
    {
      id: 'api-token',
      Header: t('api-token'),
      Cell: (props: CellProps<ApiToken>) => (
        <TextCell {...props} value="••••••••••••••••••••" />
      ),
      minWidth: 180,
      maxWidth: 180,
      width: 180,
    },
    {
      id: 'status',
      Header: t('status'),
      Cell: ({ item }: CellProps<ApiToken>) => {
        return (
          <ApiTokenStatusChip
            apiToken={item}
            onStatusChangeHandler={onStatusChangeHandler}
          />
        );
      },
      minWidth: 120,
      maxWidth: 120,
      width: 120,
    },
    {
      id: 'createdAt',
      Header: t('date-created'),
      accessorFn: ({ item }: CellProps<ApiToken>) =>
        item.createdAt
          ? getFormattedDate(item.createdAt, dateTimeFormatEU)
          : '-',
      Cell: (props: CellProps<ApiToken>) => <TextCell {...props} />,
      minWidth: 200,
      maxWidth: 200,
      width: 200,
    },
  ];
}
